// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"323":"7cd623fd","386":"324ba9eb","574":"123fd98e"}[chunkId] + ".chunk.js";
};